// @ts-nocheck
class WIcontactpop extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.openPop();    
        this.closePop();
    }

    disconnectedCallback() {
        this.openPop();    
        this.closePop();
    }

    // open pop
    openPop() {
        // opCP = contact Pop opner
        let opCP = document.querySelector('#jewelleryexpertopner');
        const handleOpen = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.style.display = "flex";
            requestAnimationFrame(() => {
                this.classList.add('WI_contactPop_main_active');
                this.querySelector('.WI_contactPop_in').classList.add('WI_contactPop_in_active');
            });
        };
        opCP?.addEventListener('click', handleOpen);
        opCP?.addEventListener('touchstart', handleOpen, { passive: false });
    }

    // close pop
    closePop() {
        // clCP = contact Pop opner
        let clCP = this.querySelector('.WI_contactPop_in_cls');
        const handleClose = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.classList.remove('WI_contactPop_main_active');
            this.querySelector('.WI_contactPop_in').classList.remove('WI_contactPop_in_active');
            setTimeout(() => {
                this.style.display = "none";
            },410);
        };
        clCP?.addEventListener('click', handleClose);
        clCP?.addEventListener('touchstart', handleClose, { passive: false });
    }
} 

customElements.define('wi-contact-pop',WIcontactpop);